<script lang="ts">
	import DefaultContentContainer from '$lib/components/DefaultContentContainer.svelte';
	import LoginLink from '$lib/components/LoginLink.svelte';
	import type { PageData } from './$types';
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FlowContent from '$lib/components/FlowContent/FlowContent.svelte';

	export let data: PageData;
</script>

<svelte:head>
	<title>{$_('pages.ticketboerse.title')}</title>
</svelte:head>

<DefaultContentContainer textHeavy={true}>
	<FlowContent data={data.flowContent} />
	<div class="col-12 mt-4 mb-4 text-center">
		<LoginLink
			redirectUri={data.redirect_uri || $page.url.pathname}
			classNames={['btn btn-primary btn-bold normal-case']}
		>
			Jetzt zum Login
		</LoginLink>
	</div>
</DefaultContentContainer>

<div class="highlight p-2 pb-0">
	<h5>Mit wenigen Klicks Dein Ticket sicher an Schalker weiterverkaufen</h5>

	<div
		class="d-flex flex-row flex-column flex-lg-row justify-content-between align-items-center align-items-lg-start"
	>
		<div class="item d-flex flex-column align-items-center text-center mb-2 px-1">
			<svg
				version="1.1"
				id="Ebene_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 400 400"
				style="enable-background:new 0 0 400 400;"
				xml:space="preserve"
				class="mb-1"
			>
				<style type="text/css">
					.st0 {
						fill: #004d9d;
					}
					.st1 {
						font-family: 'Schalke04Text-Bold', sans-serif;
					}
					.st2 {
						font-size: 208.161px;
					}
					.st3 {
						fill: #414141;
					}
				</style>
				<text transform="matrix(1 0 0 1 16.5347 387.5384)" class="st0 st1 st2">1</text>
				<g>
					<path
						class="st3"
						d="M302.84,31.15H160.98c-19.46,0-35.29,15.83-35.29,35.29v11.06c0,6.98,5.65,12.63,12.63,12.63
		s12.63-5.65,12.63-12.63V66.44c0-5.53,4.5-10.03,10.03-10.03h141.86c5.53,0,10.03,4.5,10.03,10.03V294.1
		c0,5.53-4.5,10.03-10.03,10.03H160.98c-5.53,0-10.03-4.5-10.03-10.03v-11.06c0-6.98-5.65-12.63-12.63-12.63
		s-12.63,5.65-12.63,12.63v11.06c0,19.46,15.83,35.29,35.29,35.29h141.86c19.46,0,35.29-15.83,35.29-35.29V66.44
		C338.13,46.98,322.3,31.15,302.84,31.15z"
					/>
					<path
						class="st3"
						d="M174.73,219.54c-4.28,5.51-3.28,13.44,2.23,17.72c2.3,1.79,5.03,2.65,7.73,2.65c3.77,0,7.5-1.68,9.99-4.89
		l36.2-46.64c1.84-2.19,2.95-5.02,2.95-8.1c0-3.05-1.08-5.84-2.87-8.02l-36.28-46.74c-4.28-5.51-12.21-6.51-17.72-2.23
		c-5.51,4.28-6.51,12.21-2.23,17.72l20.68,26.65H74.5c-6.98,0-12.63,5.65-12.63,12.63c0,6.98,5.65,12.63,12.63,12.63h120.91
		L174.73,219.54z"
					/>
				</g>
			</svg>
			<span class="text-sm text-bold">Mit deinem Schalke-Account anmelden</span>
		</div>
		<div class="item d-flex flex-column align-items-center text-center mb-2 px-1">
			<svg
				version="1.1"
				id="Ebene_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 400 400"
				style="enable-background:new 0 0 400 400;"
				xml:space="preserve"
				class="mb-1"
			>
				<style type="text/css">
					.st0 {
						fill: #004d9d;
					}
					.st2 {
						font-size: 208.161px;
					}
					.st3 {
						fill-rule: evenodd;
						clip-rule: evenodd;
						fill: #414141;
					}
					.st4 {
						fill: #ffffff;
						stroke: #ffffff;
						stroke-width: 3;
						stroke-miterlimit: 11.3386;
					}
					.st5 {
						fill: #414141;
					}
				</style>
				<text transform="matrix(1 0 0 1 16.5347 387.5384)" class="st0 st1 st2">2</text>
				<g>
					<path
						id="path817-3"
						class="st3"
						d="M26.07,94.74c0,0-4.21-19.07,14.87-23.28L327.06,8.33c19.07-4.21,23.28,14.87,23.28,14.87
		l8.42,38.15c-19.07,4.21-14.87,23.28-14.87,23.28c4.21,19.07,23.28,14.87,23.28,14.87l8.42,38.15
		c4.21,19.07-14.87,23.28-14.87,23.28L74.61,224.05c0,0-19.07,4.21-23.28-14.87l-8.42-38.15c0,0,19.07-4.21,14.87-23.28
		c0,0-4.21-19.07-23.28-14.87L26.07,94.74z"
					/>
					<g id="g839-9" transform="matrix(1,0,0,0.9549874,226.02976,8.4181694)">
						<path id="path827-1" class="st4" d="M60.2,23.11l4.02,19.07" />
						<path id="path829-2" class="st4" d="M68.24,61.26l4.02,19.07" />
						<path id="path831-7" class="st4" d="M76.27,99.41l4.02,19.07" />
						<path id="path833-0" class="st4" d="M84.31,137.56l4.02,19.07" />
					</g>
				</g>
				<g id="XMLID_389_">
					<g id="XMLID_414_">
						<g id="XMLID_445_">
							<g id="XMLID_446_">
								<g id="XMLID_992_">
									<path
										id="XMLID_1837_"
										class="st5"
										d="M244.99,170.92c15.13,0,29.47,3.37,42.31,9.41c0.6,0.27,1.19,0.55,1.76,0.85
						c0.42,0.19,0.83,0.41,1.24,0.61c0.01,0,0.01,0,0.01,0c0.7,0.35,1.38,0.72,2.06,1.09c20.3,10.97,36.37,28.79,45.09,50.37
						c1.92,4.73,3.49,9.64,4.68,14.71c1.69,7.29,2.59,14.9,2.59,22.71c0,4.78-0.34,9.49-1,14.08c-0.19,1.42-0.42,2.84-0.68,4.23
						c-4.12,22.16-15.55,41.77-31.72,56.16c-2.07,1.85-4.21,3.61-6.43,5.28c-4.57,3.45-9.45,6.5-14.59,9.13
						c-3.03,1.54-6.15,2.93-9.34,4.16c-11.16,4.33-23.3,6.71-35.99,6.71c-2.7,0-5.36-0.11-8-0.31c-2.19-0.18-4.38-0.42-6.53-0.74
						c-4.53-0.67-8.94-1.62-13.25-2.88c-1.99-0.57-3.97-1.21-5.9-1.91c-5.53-1.98-10.84-4.44-15.87-7.32
						c-0.68-0.4-1.34-0.79-1.99-1.19c-0.55-0.33-1.08-0.67-1.61-0.99c-0.53-0.34-1.05-0.68-1.55-1.01c-1-0.64-1.98-1.31-2.94-2
						c-0.26-0.19-0.53-0.38-0.79-0.56c-0.2-0.15-0.4-0.29-0.59-0.42c-4.84-3.57-9.35-7.55-13.47-11.91
						c-1.08-1.13-2.13-2.29-3.13-3.46c-1.62-1.88-3.18-3.83-4.65-5.83c-0.71-0.95-1.4-1.92-2.06-2.9
						c-10.99-16.02-17.41-35.41-17.41-56.3c0-1.21,0.03-2.43,0.07-3.63c0.05-1.72,0.16-3.41,0.31-5.1
						c2.03-23.46,12.19-44.59,27.63-60.58c1.05-1.09,2.14-2.17,3.24-3.2c16.21-15.32,37.55-25.26,61.16-26.98
						c1.54-0.11,3.08-0.18,4.63-0.23C243.2,170.93,244.09,170.92,244.99,170.92L244.99,170.92z M244.99,163.73
						c-0.92,0-1.83,0.01-2.75,0.03c-1.82,0.06-3.45,0.13-5.07,0.25c-24.46,1.78-47.75,12.05-65.59,28.92
						c-1.17,1.1-2.35,2.26-3.49,3.44c-16.99,17.59-27.51,40.66-29.61,64.94c-0.17,1.91-0.28,3.71-0.34,5.49
						c-0.04,1.26-0.07,2.56-0.07,3.85c0,21.69,6.45,42.56,18.67,60.36c0.67,1,1.43,2.07,2.22,3.12c1.55,2.11,3.23,4.22,4.98,6.24
						c1.08,1.26,2.21,2.51,3.37,3.72c4.35,4.6,9.2,8.9,14.41,12.74l0.6,0.43l0.1,0.07l0.1,0.07c0.19,0.13,0.39,0.27,0.58,0.41
						c1.14,0.82,2.22,1.55,3.32,2.26l0.51,0.33l1.05,0.68l0.67,0.42c0.37,0.23,0.74,0.46,1.11,0.68c0.68,0.41,1.37,0.83,2.08,1.24
						c5.51,3.15,11.24,5.79,17.05,7.87c2.09,0.75,4.22,1.44,6.33,2.05c4.55,1.32,9.33,2.36,14.19,3.08c2.3,0.34,4.65,0.6,7,0.79
						c2.9,0.22,5.78,0.34,8.58,0.34c13.31,0,26.29-2.42,38.59-7.19c3.38-1.3,6.76-2.8,10-4.45c5.52-2.82,10.78-6.12,15.66-9.8
						c2.33-1.74,4.65-3.65,6.89-5.65c17.62-15.69,29.7-37.07,33.99-60.2c0.28-1.5,0.53-3.04,0.74-4.58
						c0.7-4.92,1.06-9.99,1.06-15.04c0-8.2-0.93-16.39-2.78-24.33c-1.26-5.38-2.95-10.69-5.02-15.79
						c-9.29-22.98-26.46-42.16-48.33-53.98c-0.75-0.4-1.47-0.79-2.21-1.17l-1.54-0.78h-0.05c-0.56-0.28-1.13-0.55-1.72-0.81
						C276.12,167.13,260.85,163.73,244.99,163.73L244.99,163.73z"
									/>
								</g>
							</g>
						</g>
						<g id="XMLID_416_">
							<g id="XMLID_439_">
								<path
									id="XMLID_440_"
									class="st5"
									d="M342.72,247.81c-1.17-5.04-2.77-10.01-4.7-14.79c-8.73-21.57-24.84-39.58-45.37-50.67
					c-0.69-0.36-1.36-0.74-2.07-1.09l-0.35-0.18c-0.31-0.16-0.62-0.3-0.91-0.43c-0.58-0.3-1.17-0.58-1.78-0.86
					c-13.36-6.28-27.68-9.46-42.57-9.46c-0.89,0-1.76,0.01-2.71,0.02c-1.27,0.05-2.95,0.11-4.66,0.23
					c-22.92,1.67-44.78,11.3-61.53,27.14c-1.11,1.05-2.21,2.14-3.26,3.22c-15.95,16.52-25.82,38.16-27.8,60.94
					c-0.16,1.81-0.25,3.49-0.31,5.13c-0.04,1.21-0.07,2.43-0.07,3.65c0,20.35,6.06,39.94,17.51,56.63c0.59,0.89,1.26,1.82,2.08,2.93
					c1.07,1.46,2.21,2.91,3.38,4.32c0.42,0.52,0.86,1.04,1.29,1.55c1.01,1.17,2.08,2.34,3.15,3.48c4.11,4.35,8.66,8.38,13.56,11.99
					l0.59,0.43c0.25,0.17,0.52,0.35,0.79,0.54c0.95,0.7,1.96,1.38,2.96,2.03l2.19,1.39c0.33,0.21,0.66,0.42,1.03,0.64
					c0.65,0.39,1.29,0.78,1.98,1.17c5.13,2.93,10.51,5.42,15.95,7.37c1.96,0.7,3.96,1.35,5.94,1.92c1.56,0.45,3.13,0.87,4.73,1.24
					c2.81,0.66,5.69,1.22,8.6,1.64c2.15,0.31,4.36,0.57,6.57,0.75c2.69,0.21,5.4,0.31,8.04,0.31c12.5,0,24.67-2.27,36.21-6.75
					c3.2-1.23,6.35-2.63,9.4-4.18c5.17-2.64,10.1-5.74,14.67-9.19c2.2-1.64,4.37-3.43,6.47-5.3c16.55-14.73,27.87-34.81,31.91-56.51
					c0.28-1.46,0.51-2.89,0.69-4.25c0.66-4.66,1-9.42,1-14.17C345.33,262.95,344.45,255.27,342.72,247.81z M343.3,283.34
					c0.01,0.01,0,0.01,0,0.01c-0.05,0.43-0.11,0.87-0.17,1.3c-0.08,0.68-0.19,1.36-0.3,2.07v0.01c-0.12,0.7-0.24,1.41-0.37,2.13
					c-3.99,21.44-15.18,41.27-31.53,55.82c-1.2,1.08-2.42,2.11-3.65,3.1c-0.91,0.74-1.82,1.45-2.74,2.14
					c-0.54,0.41-1.09,0.81-1.64,1.21c-3.26,2.37-6.69,4.54-10.25,6.49c-0.86,0.48-1.73,0.94-2.61,1.39
					c-1.28,0.65-2.58,1.28-3.9,1.86c-1.76,0.82-3.56,1.57-5.37,2.27c-11.39,4.42-23.43,6.67-35.77,6.67c-2.61,0-5.29-0.11-7.95-0.31
					c-1.13-0.08-2.27-0.19-3.39-0.33c-1.04-0.12-2.08-0.25-3.1-0.41c-0.74-0.11-1.46-0.23-2.2-0.35c-1.52-0.25-3.02-0.54-4.52-0.87
					c-1.5-0.33-2.98-0.68-4.44-1.08c-0.68-0.18-1.34-0.36-2-0.56c-1-0.29-2.02-0.6-3.02-0.93c-0.95-0.3-1.91-0.63-2.85-0.97
					c-5.39-1.93-10.69-4.37-15.77-7.28c-0.66-0.39-1.3-0.77-1.98-1.17c-0.33-0.21-0.65-0.41-0.98-0.62l-2.16-1.38
					c-0.99-0.64-1.98-1.32-2.91-1.99c-0.27-0.19-0.54-0.39-0.8-0.56l-0.58-0.42c-4.84-3.56-9.35-7.55-13.39-11.85
					c-0.5-0.52-0.99-1.05-1.47-1.58c-0.56-0.6-1.11-1.23-1.64-1.85c-0.36-0.41-0.71-0.83-1.06-1.26c-0.33-0.4-0.65-0.8-0.97-1.2
					c-0.66-0.82-1.32-1.65-1.94-2.49c-0.22-0.29-0.43-0.58-0.65-0.87c-0.39-0.52-0.74-0.99-1.04-1.45c-0.36-0.51-0.69-0.98-1-1.44
					c-11.32-16.5-17.31-35.84-17.31-55.95c0-1.21,0.04-2.42,0.07-3.6c0.02-0.86,0.07-1.73,0.13-2.61c0.05-0.8,0.11-1.62,0.18-2.46
					c0.05-0.51,0.1-1.01,0.14-1.52c2.2-21.52,11.55-41.92,26.42-57.74c0.29-0.31,0.59-0.63,0.89-0.94c0.48-0.51,0.98-1,1.49-1.5
					c0.57-0.57,1.15-1.13,1.74-1.69c16.54-15.64,38.14-25.17,60.79-26.81c0.86-0.06,1.7-0.11,2.5-0.14c0.77-0.04,1.5-0.07,2.14-0.08
					c0.42,0,0.83-0.01,1.26-0.01c0.46-0.01,0.92-0.01,1.38-0.01c14.72,0,28.86,3.14,42.06,9.35c0.22,0.1,0.43,0.19,0.65,0.3
					c0.36,0.17,0.72,0.35,1.11,0.54c0.13,0.06,0.27,0.12,0.4,0.19c0.1,0.05,0.19,0.1,0.29,0.15c0.06,0.02,0.12,0.05,0.18,0.08
					l0.46,0.23c0.36,0.18,0.71,0.37,1.06,0.56c0.3,0.16,0.59,0.31,0.88,0.47c18.3,9.89,33.05,25.35,42.09,43.94
					c0.98,2,1.88,4.06,2.73,6.14c1.92,4.72,3.48,9.64,4.65,14.61c0.53,2.29,0.98,4.61,1.34,6.96c0.82,5.16,1.23,10.39,1.23,15.62
					C344.12,274.9,343.84,279.16,343.3,283.34z"
								/>
							</g>
							<path
								id="XMLID_431_"
								class="st5"
								d="M236.85,371.77c-2.23-0.18-4.45-0.43-6.63-0.75l-2.46-1.04c-1.38-0.65-2.49-1.23-3.38-1.7
				l-1.2-0.65c-1.05,0.27-2.31,0.44-3.72,0.51l-1.64,0.04l-1.09-0.08c-2.02-0.59-4.04-1.24-6-1.94l0.86-3.24
				c0.64,0.12,1.68,0.26,2.92,0.37c1.09,0.1,2.32,0.19,3.55,0.19c0.61,0,1.19-0.02,1.72-0.06c-2-3.63-5.14-10.09-5.82-15.82
				c-19.18-1.87-32.97-15.6-37.5-20.7l-5.35,4.61c0.29,1.12,0.83,2.81,1.86,4.92c0.3,0.6,0.61,1.25,1,1.92l-2.7,1.99
				c-1.09-1.15-2.16-2.33-3.18-3.53c-0.55-1.09-0.76-1.68-0.93-2.21c-0.3-0.86-0.49-1.59-0.64-2.16c-0.4-0.14-0.83-0.3-1.32-0.5
				c-0.37-0.15-0.82-0.34-1.25-0.55c-1.32-1.48-2.02-2.47-2.69-3.46l1.38-1.51l1.61,0.93l3.08,0.84l0.64-0.18l5.83-5l-0.45-0.88
				c-1.21-2.47-2.19-4.97-3-7.42l-0.92-3.07l-0.51-2.03c-2.29-9.73-2.04-18.33-1.44-23.86c0.21-1.8,0.43-3.21,0.6-4.14
				c-10.51-10.71-14.07-19.36-15.25-24.13c-0.2,0.15-0.41,0.31-0.61,0.49c-1.28,1.09-3.6,2.42-4.88,5.76l-1.79,4.05l-1.92-0.76
				c0.07-1.75,0.18-3.47,0.32-5.19l0.38-1.07l0.57-1.08c0.34-0.61,0.69-1.19,1.07-1.72l0.93-1.24c0.43-0.52,0.71-0.85,1.01-1.14
				l0.82-0.8l1.02-0.86l1.12-0.79l1.04-0.6c0.85-21.18,15.11-36.22,18.74-39.73l-0.18-1.3c-0.24-3.02-0.15-4.97,0.16-6.81
				c0.14-0.87,0.31-1.65,0.54-2.42l0.46-1.39c1.48-1.78,2.59-2.89,3.72-3.94l3.57-0.51c-0.46,0.6-1.94,4-2.26,4.64
				c-0.45,0.86-0.8,1.78-1.09,2.8l-0.26,1.15l-0.19,1.21l-0.1,1.16l-0.02,1.26c0,0,0.05,1.84,0.08,2.1
				c1.81-0.33,3.89-0.51,6.18-0.51c8.16,0,17.32,2.17,21.21,3.21l1.1-1.34c10.56-11.75,25.91-17.01,34.18-19.15
				c1.5-0.4,2.75-0.68,3.67-0.88c0.27-2.79,1.03-9.12,2.82-16.64c-0.32-0.23-0.85-1.13-1.54-1.87c-1.18-1.26-5.19-4.07-5.19-4.07
				c1.57-0.12,3.13-0.19,4.71-0.24l2.12,0.77l1.24,0.68c0.72,0.43,1.33,0.86,1.8,1.24l-0.09,0.37c1.38-0.17,4.38-0.5,8.36-0.5
				c7.71,0,18.46,1.17,28.55,6.34l-1.2-1.93l9.45,4.79l-0.27,1.52c4.27,2.54,12.4,8.73,19.19,21.73c-0.02-0.08,2.06,0.78,4.16,2.16
				c1.26,0.83,2.71,1.84,4.26,3.04l0.89,0.71l2.6,2.15l2.44,2.21c0.92,0.88,1.75,1.72,2.56,2.59l3.56,4.1l2.78,3.77l2.28,3.65
				l0.86,1.54l-1.11,1.51l1.69-0.41l0.52,1.04c2.12,5.17,3.71,10.21,4.89,15.26c0.43,2.48,0.69,4.92,0.8,7.39
				c0.3,6.9-0.54,14.13-2.5,21.51c0.8,1.41,1.97,3.71,2.83,6.34l0.45,1.52c-0.14,2.08-0.38,3.52-0.65,4.94l-2.17,0
				c0-0.65-0.08-1.31-0.19-1.97c-0.42-2.44-2.65-5.19-3.51-6.91c-0.26,0.2-3.41,2.44-3.41,2.44l-3.45,2.21l-5.29,2.88l-2.85,1.31
				l-1.48,0.61l-1.16,0.45l-2.59,0.88l-1.03,0.28c-3.57,19.89-18.33,35.25-22.99,39.69c0,0,1.19,3.2,1.73,4.8
				c0.82,2.36,1.7,5.14,2.42,7.85l0.41,1.59l0.25,1.14l0.44,2.34c1.56-0.33,3.91-0.65,6.84-1.81c1.59-0.63,2.92-1.34,4.27-2.37
				l1.53,1.7c-2.12,1.89-4.28,3.68-6.56,5.37c-1.13,0.52-1.84,0.77-2.51,0.98c-1.92,0.63-3.48,0.89-4.49,1
				c-0.9,1.04-2.67,2.99-5.15,5.15c-0.74,0.64-1.55,1.32-2.4,1.98c-3.34,1.73-6.52,3.15-9.76,4.4l-0.83-2.14
				c6.7-3.15,13.22-10.88,14.56-12.43c-0.09-0.96-0.14-1.31-0.21-1.67l-0.68-3.12l-0.38-1.45l-0.37-1.41l-0.36-1.21l-0.53-1.65
				l-0.65-2l-0.42-1.22l-0.67-1.89l-0.4-1.09l-0.34-0.9c-3.85,0.56-7.79,0.84-11.71,0.84c-12.71,0-22.98-2.89-27.37-4.13
				c-0.47-0.14-0.9-0.27-1.24-0.37c-0.63,0.59-1.21,1.11-1.8,1.62l-3.4,2.81l-3.52,2.58c-7.97,5.57-15.47,8.58-20.34,10.11
				c-0.89,0.29-1.66,0.51-2.29,0.68c0.86,6.77,6.09,15.44,6.73,16.46l1.57,1.2c1.86,0.98,3.89,2.53,6.68,3.5
				c1.07,0.38,2.73,1.22,3.71,1.4L236.85,371.77z M176.65,318.09l0.81,1.75l1,1.96c0.8,1.21,15.72,20.11,37.74,21.26
				c-0.14-0.03,0.99-0.27,2.75-0.8c5.14-1.59,15.27-5.53,25.22-13.95l1.03-0.89l0.91-0.81c-0.91-15-4.51-43.48-4.51-43.48
				l-2.95-1.26c-12.2-5.4-25.92-13.8-33.02-18.33l-2.47-1.6c-9.07,4.14-27.17,17.73-30.4,20.19c-0.15,0.82-0.4,2.2-0.59,4.01
				c-0.24,2.21-0.44,5.06-0.38,8.35l0.03,1.44l0.07,1.5l0.09,1.27l0.16,1.82l0.15,1.41l0.24,1.68l0.2,1.15l0.29,1.57l0.34,1.58
				l0.25,1.1l0.35,1.35l0.36,1.28l0.49,1.57l0.36,1.09L176.65,318.09z M252.32,325.23c4.28,1.21,14.15,4,26.29,4
				c4.32,0,8.58-0.35,12.64-1.04c-0.04-0.3,18.12-16.59,21.77-37.99c-8.45-10.7-21.74-25.57-26.93-27.75
				c-13.77,9.17-34.21,18.45-39.28,20.7c0.66,6.23,4.59,41.8,4.59,41.8C251.67,325.03,251.97,325.12,252.32,325.23z M288.42,258.41
				c8.27,4.18,23.43,22.8,27.97,28.49l0.12-0.03c1.91-0.58,3.03-0.97,4.13-1.4c8.75-3.45,15.91-9.19,17.26-10.31
				c3.29-13.1,2.88-26.01-1.77-37.53c-0.45-1.11-0.93-2.19-1.46-3.23l-0.8-1.6l-1.79-3.11l-0.77-1.23l-1.17-1.72l-1.03-1.42
				l-0.8-1.04l-0.82-1.02l-0.94-1.12l-1.42-1.57l-0.83-0.89l-1.59-1.58c-2.93-2.83-5.98-5.29-9.21-7.44
				c-1.93-1.3-3.47-2.17-4.33-2.62c-6.23,1.7-16.89,5.16-21.87,8.58l0.1,0.37c0.46,1.98,0.77,3.47,1.03,4.92
				c3.12,16.82,1.16,30.55,0.19,35.68L288.42,258.41z M237.11,276.02c1.21,0.57,2.5,1.17,3.78,1.72l3.38,1.41
				c4.57-2.03,25.78-11.61,39.33-20.69l0.34-1.59c0.83-4.26,2.1-13.1,1.15-24.54l-0.18-1.76l-0.21-1.89l-0.22-1.67l-0.19-1.25
				l-0.24-1.52l-0.3-1.81l-0.29-1.33c-0.37-1.82-0.7-3.23-1.08-4.63v0.01c-0.46,0-20.54-16.98-38.76-20.07
				c-0.75,0.14-2.55,0.5-5.03,1.16c-3.9,1.03-9.84,2.9-15.94,5.97l-3.16,1.71l-1.56,0.93l-1.34,0.82l-3.22,2.31l-2.75,2.29
				l-1.65,1.56c-0.53,0.52-0.99,1.03-1.44,1.54c-0.42,0.45-0.76,0.87-1.1,1.28l-1.12,1.46c-0.2,1.23-4.18,17.6,0.15,40.43l5.55,3.53
				l0.96,0.62l3.57,2.17l1.08,0.66l6.02,3.51l1.48,0.83l1.55,0.88l1.49,0.82l1,0.53l1.2,0.65l1.05,0.55l1.64,0.87l1.27,0.63
				l1.31,0.66L237.11,276.02z M181.29,214.93c-2.91,0-5.36,0.3-7.27,0.9c-1.14,1.22-16.56,15.59-17.09,37.54
				c0.19,2.77,1.72,11.66,13.93,24.33c4.8-3.61,20.79-15.46,29.88-19.79c-3.59-19.73-1.27-34.73-0.15-40.09
				C196.92,216.87,188.54,214.93,181.29,214.93z M246.16,192.13c16.36,3.46,33.33,16.33,38.56,20.57
				c5.52-3.72,15.47-6.96,21.21-8.63c-7.42-12.9-15.67-17.43-18.11-18.55l-1.28-0.55c-10.44-6.99-22.55-8.45-30.87-8.45
				c-3.03,0-5.46,0.2-6.93,0.36C247.17,183.61,246.45,189.26,246.16,192.13z"
							/>
							<path
								id="XMLID_420_"
								class="st5"
								d="M343.3,283.35v-0.01c-1.04-3.19-2.57-5.83-3.04-6.63c2.07-7.51,2.93-14.75,2.63-21.67
				c-0.11-2.4-0.36-4.77-0.76-7.09c-1.18-5.07-2.75-9.98-4.67-14.71c-0.08-0.18-0.16-0.37-0.25-0.54c-0.11-0.22-0.22-0.42-0.33-0.64
				c-0.21-0.4-0.4-0.79-0.62-1.16c-0.11-0.23-0.24-0.45-0.37-0.66c-0.18-0.37-0.39-0.72-0.59-1.08c-0.13-0.23-0.28-0.45-0.41-0.68
				c-0.21-0.33-0.41-0.66-0.62-0.99c-0.04-0.05-0.07-0.11-0.1-0.16c-0.12-0.17-0.23-0.33-0.34-0.51c-0.21-0.33-0.42-0.64-0.63-0.97
				c-0.14-0.21-0.3-0.42-0.43-0.63c-0.23-0.31-0.45-0.63-0.66-0.92c-0.16-0.21-0.29-0.4-0.43-0.59c-0.24-0.31-0.47-0.63-0.71-0.93
				c-0.13-0.17-0.28-0.35-0.41-0.53c-0.25-0.31-0.51-0.63-0.76-0.94c-0.12-0.14-0.27-0.29-0.39-0.45c-0.29-0.34-0.57-0.66-0.86-1
				l-0.29-0.33c-0.37-0.42-0.76-0.85-1.16-1.26v-0.01c-0.8-0.84-1.61-1.67-2.4-2.43l-0.11-0.11c-0.36-0.35-0.71-0.68-1.06-1
				c-0.07-0.06-0.14-0.12-0.19-0.17c-0.33-0.3-0.65-0.59-0.98-0.88c-0.07-0.06-0.16-0.12-0.23-0.18c-0.3-0.28-0.62-0.56-0.93-0.81
				c-0.07-0.06-0.15-0.11-0.21-0.17c-0.31-0.27-0.63-0.53-0.94-0.77c-0.06-0.04-0.82-0.65-1.15-0.89c-0.02-0.04-0.07-0.06-0.07-0.06
				c-1.53-1.17-2.95-2.16-4.18-2.97c-2.43-1.59-4.18-2.51-4.73-2.79c-7.42-14.17-16.26-19.9-19.87-21.79c0,0,0.06-0.01,0.08-0.02
				c0.08-0.05,0.18-0.07,0.29-0.1c0.05-0.02,0.1-0.05,0.16-0.06c0.08-0.02,0.19-0.05,0.3-0.07c0.06-0.02,0.12-0.04,0.18-0.05
				c0.05-0.01,0.1-0.02,0.14-0.02c0.06-0.01,0.13-0.01,0.19-0.02c0.06-0.01,0.11-0.04,0.18-0.04c0.17-0.01,0.34-0.02,0.52-0.02
				c0.1,0,0.19,0,0.28,0.02c-0.69-0.36-1.36-0.74-2.07-1.09c0,0,0,0-0.01,0c-0.19,0.07-0.39,0.12-0.57,0.19
				c-0.04,0.01-0.07,0.02-0.1,0.04c-0.05,0.02-0.1,0.04-0.13,0.05c-0.08,0.04-0.17,0.07-0.24,0.11l-0.01-0.05
				c-0.01-0.07-0.01-0.13-0.04-0.21c-0.02-0.23-0.08-0.47-0.16-0.75c-0.57-0.3-1.16-0.57-1.75-0.85c0.05,0.07,0.11,0.16,0.14,0.24
				c0.01,0.02,0.02,0.05,0.04,0.07c0.06,0.11,0.11,0.23,0.17,0.36c0,0.04,0.01,0.07,0.02,0.11c0.01,0.02,0.01,0.05,0.02,0.07
				c0.02,0.08,0.05,0.16,0.07,0.23c0,0.05,0.01,0.08,0.02,0.14c0.04,0.11,0.06,0.23,0.07,0.34c0.01,0.05,0.01,0.07,0.02,0.11
				c0.01,0.1,0.04,0.19,0.05,0.29c-10.97-7.26-23.57-8.78-32.26-8.78c-4.24,0-7.35,0.39-8.48,0.53c-0.02-0.02-0.05-0.07-0.1-0.11
				c-0.08-0.08-0.17-0.19-0.28-0.29c-0.04-0.02-0.06-0.05-0.08-0.06c-0.11-0.1-0.22-0.19-0.33-0.29c-0.04-0.01-0.06-0.02-0.06-0.02
				c-0.43-0.35-0.97-0.72-1.59-1.1c-0.36-0.21-0.75-0.42-1.16-0.63c-0.41-0.21-0.85-0.4-1.3-0.59c-1.56,0.05-3.09,0.12-4.64,0.23
				c0.07,0,0.15,0.01,0.22,0.01c0.24,0.02,0.5,0.06,0.74,0.1c0.01,0,0.02,0,0.02,0c0.53,0.08,1.06,0.21,1.57,0.35
				c0.98,0.28,1.9,0.65,2.72,1.05l0.01,0.01c0.06,0.04,0.13,0.07,0.19,0.1c0.08,0.05,0.17,0.08,0.24,0.12
				c0.07,0.05,0.13,0.07,0.21,0.11c0.07,0.05,0.13,0.08,0.21,0.13c1.24,0.68,2.11,1.36,2.37,1.65c-2.26,9.14-2.98,16.7-3.14,18.67
				c-0.8,0.14-2.5,0.5-4.81,1.1c-7.96,2.07-23.09,7.22-32.75,17.98c-0.21,0.22-0.41,0.45-0.6,0.68c-0.22,0.24-0.45,0.51-0.65,0.76
				c-0.16,0.21-0.33,0.41-0.5,0.63c-0.18,0.25-0.39,0.5-0.57,0.74c-2.32-0.65-12.75-3.44-21.85-3.44c-2.95,0-5.5,0.28-7.6,0.87
				c-0.01-0.06-0.01-0.11-0.02-0.16c-0.01-0.12-0.05-0.23-0.06-0.35c-0.01-0.07-0.02-0.13-0.02-0.21c-0.02-0.16-0.05-0.33-0.08-0.52
				c-0.06-0.46-0.1-0.98-0.13-1.55c-0.02-0.43-0.04-0.89-0.04-1.38v-0.47c0-0.21,0.01-0.42,0.01-0.63c0.01-0.15,0.01-0.29,0.02-0.45
				c0.01-0.16,0.02-0.33,0.04-0.51c0.04-0.21,0.05-0.41,0.07-0.63c0.01-0.12,0.04-0.25,0.06-0.37c0.04-0.28,0.07-0.53,0.13-0.81
				c0.01-0.1,0.02-0.17,0.04-0.25c0.07-0.33,0.16-0.65,0.23-0.98c0.02-0.05,0.02-0.08,0.04-0.13c0.29-1.04,0.68-2.09,1.21-3.13
				c0.37-0.72,0.81-1.44,1.33-2.13c-1.11,1.03-2.2,2.11-3.25,3.2c-0.17,0.46-0.33,0.91-0.46,1.36c-0.21,0.71-0.36,1.42-0.48,2.13
				c0,0.02-0.01,0.07-0.01,0.11c-0.34,1.98-0.35,3.84-0.24,5.39c0.02,0.35,0.06,0.68,0.1,0.98v0.02c0.04,0.41,0.08,0.79,0.14,1.12
				v0.04c0.05,0.31,0.11,0.6,0.14,0.86c0,0,0.01,0.01,0.01,0.04c-2.2,1.99-17.97,17.06-18.55,39.9c0,0,0,0.04,0,0.08
				c-0.21,0.08-0.47,0.19-0.79,0.36c-0.02,0.01-0.05,0.01-0.05,0.01c-0.19,0.11-0.39,0.22-0.6,0.33c-0.01,0.01-0.04,0.01-0.05,0.02
				c-0.21,0.12-0.42,0.24-0.64,0.4c-0.06,0.04-0.13,0.07-0.19,0.13c-0.17,0.11-0.36,0.24-0.54,0.39c-0.06,0.05-0.13,0.1-0.21,0.15
				c-0.01,0.01-0.01,0.01-0.02,0.02c-0.22,0.17-0.46,0.37-0.68,0.57c-0.08,0.06-0.17,0.13-0.24,0.19c-0.18,0.18-0.37,0.36-0.58,0.57
				c-0.07,0.06-0.15,0.14-0.22,0.22c-0.27,0.27-0.52,0.56-0.77,0.86c-0.05,0.07-0.1,0.12-0.14,0.18c-0.23,0.28-0.45,0.57-0.66,0.88
				c-0.07,0.08-0.12,0.14-0.18,0.24c-0.34,0.48-0.65,1-0.97,1.56c-0.18,0.34-0.36,0.68-0.54,1.04c-0.02,0.08-0.07,0.15-0.11,0.23
				c-0.02,0.07-0.07,0.13-0.1,0.21c-0.14,1.69-0.25,3.38-0.31,5.1c0.11-0.45,0.22-0.91,0.34-1.32c0.04-0.13,0.07-0.25,0.11-0.37
				c0.1-0.3,0.18-0.6,0.29-0.89c0.05-0.17,0.11-0.34,0.17-0.5c0.02-0.07,0.05-0.13,0.07-0.21c1.33-3.47,3.19-5.7,4.83-7.09
				c1.17-1.01,2.23-1.59,2.9-1.9c0.48,3.57,2.97,13.33,15.89,26.26c-0.15,0.7-0.47,2.42-0.75,4.88c-0.57,5.18-0.87,13.7,1.35,23.14
				c0.01,0.05,0.02,0.11,0.04,0.14c0.12,0.51,0.24,0.99,0.37,1.5c0.07,0.24,0.13,0.51,0.21,0.76c0.1,0.31,0.18,0.63,0.27,0.94
				c0.17,0.59,0.36,1.16,0.56,1.75v0.01c0.79,2.39,1.74,4.82,2.91,7.22c0.33,0.68,0.68,1.35,1.04,2.03l-7.52,6.47c0,0,0,0-0.01,0
				c-0.07-0.02-0.16-0.05-0.24-0.07c-0.08-0.02-0.17-0.06-0.27-0.08c-0.01-0.01-0.04-0.01-0.06-0.04c-0.17-0.05-0.36-0.12-0.57-0.19
				c-0.05-0.02-0.1-0.05-0.14-0.06c-0.22-0.08-0.43-0.17-0.68-0.25c-0.07-0.05-0.17-0.07-0.25-0.11c-0.23-0.1-0.46-0.21-0.71-0.31
				c-0.08-0.05-0.17-0.08-0.27-0.14c-0.17-0.07-0.35-0.16-0.52-0.25c-0.11-0.07-0.23-0.12-0.34-0.19c-0.06-0.04-0.12-0.06-0.17-0.11
				c-0.14-0.07-0.29-0.16-0.42-0.24c-0.1-0.06-0.19-0.12-0.28-0.19c-0.21-0.13-0.39-0.29-0.57-0.43c-0.07-0.06-0.12-0.11-0.18-0.17
				c-0.01-0.01-0.04-0.04-0.05-0.05c0.65,0.98,1.35,1.94,2.05,2.9c0.39,0.19,0.77,0.36,1.14,0.51c0.88,0.36,1.65,0.62,2.11,0.76
				l0.01,0.08c0.11,0.56,0.34,1.52,0.79,2.84c0.17,0.5,0.36,1.05,0.6,1.64c1.01,1.17,2.07,2.33,3.14,3.47
				c-0.39-0.7-0.74-1.38-1.04-2c-1.55-3.2-2.05-5.47-2.21-6.28l7.4-6.36c2.68,3.26,17.54,20.13,38.88,21.52
				c0.28,7.09,5.39,16.1,6.92,18.66c-1.14,0.31-2.6,0.47-4.38,0.47c-1.29,0-2.57-0.08-3.71-0.19c-1.3-0.12-2.39-0.28-3.06-0.4
				c1.93,0.69,3.91,1.33,5.91,1.91c0.29,0.01,0.57,0.01,0.86,0.01c0.46,0,0.89-0.01,1.32-0.04c1.61-0.07,2.95-0.29,4-0.64
				c0.34,0.19,0.97,0.54,1.8,0.98c0.87,0.47,1.96,1.03,3.16,1.61c0.68,0.31,1.39,0.64,2.11,0.95c2.15,0.31,4.34,0.56,6.53,0.74
				c-1.05-0.19-2.2-0.52-3.35-0.93c-2.87-1-5.81-2.46-7.72-3.48c-1-0.53-1.73-0.94-2-1.1c-0.76-1.23-6.82-11.22-7.09-18.63
				c0.07-0.01,0.19-0.04,0.28-0.07c0.01,0,0.01,0,0.01,0c0.71-0.17,1.84-0.46,3.3-0.93c4.44-1.4,11.94-4.35,20.04-9.99
				c0.13-0.07,0.25-0.17,0.37-0.25c0.41-0.3,0.83-0.59,1.24-0.91c0.57-0.42,1.16-0.86,1.73-1.3c0.29-0.22,0.57-0.45,0.86-0.68
				c0.64-0.52,1.28-1.05,1.92-1.59c0.18-0.16,0.34-0.3,0.52-0.46c0.74-0.64,1.46-1.3,2.2-1.99c0.06-0.06,0.13-0.13,0.22-0.19
				c0.36,0.06,1.17,0.29,2,0.54c4.32,1.22,14.44,4.12,27.09,4.12c4.32,0,8.64-0.35,12.79-1.03c0.02,0.04,0.04,0.07,0.05,0.1
				c0.04,0.11,0.08,0.23,0.12,0.35c0.04,0.1,0.1,0.22,0.13,0.34c0.06,0.15,0.11,0.29,0.17,0.46c0.05,0.13,0.11,0.28,0.17,0.43
				c0.06,0.16,0.13,0.34,0.19,0.52c0.07,0.21,0.17,0.43,0.25,0.66c0.05,0.14,0.11,0.29,0.16,0.45c0.13,0.39,0.28,0.79,0.42,1.18
				c0.04,0.13,0.08,0.27,0.13,0.39c0.08,0.23,0.17,0.46,0.24,0.7c0.05,0.13,0.08,0.27,0.13,0.4c0.06,0.17,0.12,0.33,0.18,0.51
				c0.11,0.31,0.22,0.64,0.33,0.98c0.06,0.19,0.12,0.4,0.18,0.59c0.11,0.33,0.21,0.64,0.31,0.97c0.07,0.22,0.14,0.43,0.21,0.65
				c0.1,0.31,0.19,0.63,0.29,0.94c0.07,0.23,0.12,0.45,0.19,0.66c0.1,0.34,0.19,0.66,0.27,0.98c0.07,0.22,0.13,0.43,0.18,0.65
				c0.1,0.33,0.18,0.66,0.25,0.99c0.06,0.21,0.12,0.4,0.16,0.6c0.1,0.35,0.18,0.71,0.24,1.06c0.05,0.16,0.08,0.33,0.11,0.5
				c0.11,0.47,0.21,0.93,0.28,1.4c0.01,0.01,0.01,0.04,0.02,0.06c0.08,0.5,0.16,0.95,0.19,1.4c0.01,0.11,0.02,0.22,0.04,0.33
				c0.04,0.27,0.05,0.54,0.06,0.8c-0.8,0.97-4.85,5.7-10.93,9.6c-1.59,1.04-3.31,2-5.16,2.84c3.19-1.23,6.32-2.62,9.34-4.17
				c0.83-0.64,1.62-1.29,2.33-1.92c2.91-2.54,4.81-4.76,5.42-5.5c0.68-0.04,2.42-0.21,4.83-0.99c0.63-0.19,1.29-0.43,2-0.72
				c2.22-1.67,4.36-3.42,6.44-5.28c-1.41,1.08-2.78,1.94-4.06,2.66c-4.25,2.34-7.62,2.89-8.93,3.01c-0.02-0.37-0.07-0.74-0.12-1.13
				c0-0.07-0.01-0.13-0.02-0.21c-0.06-0.36-0.11-0.74-0.18-1.11c-0.01-0.11-0.04-0.23-0.07-0.35c-0.06-0.35-0.13-0.71-0.22-1.09
				c-0.02-0.14-0.06-0.31-0.1-0.46c-0.06-0.27-0.12-0.52-0.17-0.77c-0.08-0.29-0.16-0.59-0.24-0.89c-0.04-0.19-0.08-0.39-0.13-0.56
				c-0.7-2.66-1.57-5.4-2.39-7.74c-0.66-1.96-1.29-3.64-1.71-4.77c-0.04-0.11-0.07-0.21-0.11-0.31c-0.04-0.08-0.07-0.18-0.11-0.27
				c-0.06-0.18-0.12-0.34-0.17-0.46c2.52-2.31,20.07-19,23.48-40.57c0.6-0.16,1.18-0.31,1.76-0.48c0.08-0.02,0.17-0.05,0.24-0.06
				c0.75-0.24,1.49-0.48,2.22-0.75c0.19-0.06,0.37-0.15,0.57-0.21c0.28-0.11,0.56-0.22,0.83-0.33c0.25-0.1,0.51-0.19,0.76-0.3
				c0.24-0.1,0.48-0.21,0.74-0.31c0.45-0.19,0.91-0.39,1.34-0.59c0.27-0.12,0.51-0.24,0.77-0.35c0.42-0.21,0.85-0.42,1.27-0.63
				c0.24-0.12,0.47-0.24,0.7-0.37c0.43-0.22,0.86-0.45,1.28-0.68c0.21-0.11,0.4-0.22,0.59-0.31c0.53-0.31,1.06-0.62,1.57-0.92
				c0.05-0.04,0.12-0.06,0.17-0.08c0.59-0.36,1.15-0.7,1.68-1.04c0.1-0.07,0.18-0.12,0.28-0.18c0.43-0.28,0.86-0.56,1.26-0.82
				c0.12-0.07,0.24-0.16,0.36-0.24c0.35-0.24,0.71-0.5,1.04-0.72c0.11-0.06,0.21-0.13,0.31-0.22c0.34-0.23,0.66-0.47,0.97-0.69
				c0.07-0.05,0.12-0.1,0.19-0.14c1.06-0.79,1.9-1.44,2.39-1.85c0.87,1.51,2.81,5.17,3.45,8.9v0.01c0.13,0.75,0.21,1.5,0.22,2.23
				c0.25-1.39,0.5-2.8,0.68-4.23C343.6,284.27,343.46,283.81,343.3,283.35z M247.39,175.35c1.06-0.14,4.12-0.52,8.3-0.52
				c8.56,0,21.01,1.52,31.8,8.74l0.1,0.04c0.05,0.01,0.3,0.11,0.71,0.28v0.01l0.17,0.06l0.07,0.04c2.75,1.26,12.02,6.38,19.9,21.11
				c-3.55,0.99-17.83,5.08-23.78,9.72c-3.03-2.52-22.34-18.19-40.32-21.33C244.5,191.48,245.2,184.24,247.39,175.35z M203.99,216.43
				c0.36-0.48,0.72-0.97,1.11-1.44c0.01-0.02,0.02-0.04,0.04-0.06c0.36-0.46,0.74-0.91,1.15-1.34c0.47-0.54,0.97-1.08,1.49-1.59
				c0.01-0.01,0.02-0.02,0.02-0.02c0.45-0.45,0.92-0.89,1.38-1.32c0.06-0.06,0.11-0.11,0.18-0.16c0.42-0.39,0.85-0.77,1.28-1.15
				c0.06-0.05,0.13-0.11,0.21-0.16c0.43-0.35,0.87-0.72,1.32-1.06c0.07-0.06,0.14-0.1,0.21-0.16c0.43-0.34,0.89-0.68,1.35-1
				c0.07-0.06,0.13-0.1,0.19-0.13c0.46-0.33,0.92-0.66,1.4-0.97c0.06-0.05,1.14-0.74,1.62-1.04c0.05-0.05,0.1-0.06,0.14-0.1
				c0.5-0.3,1-0.6,1.51-0.91c0.02-0.01,0.05-0.02,0.1-0.05c0.52-0.3,1.04-0.59,1.57-0.86c0.01-0.01,0.02-0.04,0.05-0.05
				c0.53-0.28,1.06-0.56,1.61-0.83c0,0,0-0.01,0.01-0.01c6.11-3.07,12.11-4.99,16.27-6.09c2.96-0.78,4.99-1.16,5.45-1.24
				c18.34,2.97,38.44,19.67,40.41,21.35c0.37,1.44,0.71,2.87,1,4.28c0.04,0.14,0.06,0.29,0.08,0.43c0.11,0.53,0.22,1.09,0.31,1.62
				c0,0.02,0.01,0.04,0.01,0.06c0.07,0.35,0.12,0.7,0.19,1.05c0.06,0.34,0.11,0.66,0.17,0.99c0.07,0.46,0.13,0.88,0.21,1.32
				c0.04,0.23,0.07,0.47,0.11,0.7c0.06,0.5,0.13,0.98,0.18,1.45c0.04,0.18,0.05,0.35,0.07,0.52c0.07,0.53,0.12,1.05,0.18,1.57
				c0.01,0.11,0.02,0.23,0.04,0.34c0.06,0.56,0.11,1.14,0.15,1.69c0,0.04,0.02,0.1,0.02,0.13c0.97,11.67-0.35,20.8-1.17,24.99
				c-0.22,1.16-0.41,1.94-0.5,2.29c-14.48,9.84-38.19,20.35-40.8,21.5c-0.41-0.16-0.83-0.31-1.24-0.5c-0.05-0.01-0.1-0.02-0.13-0.05
				c-0.89-0.36-1.8-0.75-2.72-1.15c-1.29-0.57-2.6-1.17-3.91-1.8c-0.11-0.06-0.23-0.11-0.34-0.17c-0.43-0.21-0.87-0.42-1.33-0.64
				c-0.24-0.12-0.48-0.24-0.71-0.35c-0.31-0.17-0.62-0.31-0.92-0.47c-0.33-0.16-0.64-0.33-0.97-0.48c-0.22-0.11-0.45-0.23-0.69-0.34
				c-0.35-0.19-0.69-0.37-1.04-0.56c-0.19-0.11-0.4-0.22-0.6-0.31c-0.37-0.21-0.74-0.39-1.12-0.59c-0.16-0.08-0.34-0.18-0.5-0.28
				c-0.4-0.21-0.8-0.42-1.2-0.64c-0.13-0.06-0.27-0.15-0.42-0.22c-0.4-0.23-0.8-0.45-1.21-0.68c-0.12-0.07-0.27-0.15-0.39-0.21
				c-0.41-0.23-0.83-0.47-1.23-0.7c-0.11-0.05-0.21-0.12-0.31-0.18c-0.42-0.23-0.85-0.47-1.27-0.7c-0.08-0.06-0.18-0.11-0.28-0.17
				c-0.42-0.24-0.83-0.47-1.24-0.7c-0.08-0.06-0.18-0.13-0.28-0.18c-0.41-0.23-0.81-0.46-1.21-0.7c-0.1-0.05-0.18-0.11-0.28-0.16
				c-0.4-0.23-0.8-0.47-1.17-0.7c-0.08-0.04-0.17-0.1-0.27-0.15c-0.37-0.23-0.76-0.45-1.15-0.69c-0.07-0.04-0.14-0.1-0.23-0.13
				c-0.37-0.23-0.75-0.45-1.11-0.66c-0.08-0.06-0.16-0.1-0.24-0.16c-0.35-0.22-0.7-0.42-1.04-0.63c-0.1-0.06-0.19-0.12-0.28-0.17
				c-0.33-0.19-0.64-0.4-0.95-0.58l-0.33-0.21c-0.28-0.17-0.56-0.35-0.83-0.51c-0.13-0.08-0.28-0.18-0.41-0.27
				c-0.23-0.13-0.46-0.29-0.66-0.42c-0.22-0.13-0.42-0.25-0.64-0.4c-0.12-0.06-0.27-0.16-0.39-0.23c-0.68-0.42-1.29-0.82-1.85-1.17
				c-1.61-1.03-2.73-1.76-3.25-2.11C199.3,235.02,203.57,218.03,203.99,216.43z M155.25,253.8c-0.01-0.3-0.01-0.46-0.01-0.47
				c0.56-22.84,16.55-37.57,18.27-39.1c2.08-0.65,4.69-0.98,7.78-0.98c8.63,0,18.76,2.64,21.3,3.36
				c-0.83,3.35-4.31,19.76,0.05,42.29c-9.17,3.91-28.5,18.42-31.94,21.04C157.12,266.27,155.45,256.5,155.25,253.8z M247.92,327.24
				c-0.22,0.23-0.45,0.42-0.66,0.63c-0.31,0.29-0.63,0.57-0.94,0.83c-0.17,0.14-0.31,0.29-0.48,0.42c-0.19,0.17-0.37,0.33-0.57,0.48
				c-10.29,8.71-20.66,12.68-25.83,14.27c-1.84,0.56-3.02,0.81-3.31,0.87c-22.93-1.21-38.21-20.75-38.8-21.51
				c-0.34-0.63-0.66-1.24-0.98-1.86c-0.07-0.14-0.13-0.28-0.21-0.42c-0.04-0.07-0.07-0.16-0.11-0.23c-0.19-0.4-0.4-0.81-0.57-1.22
				c-0.12-0.25-0.24-0.53-0.36-0.79c-0.14-0.35-0.3-0.71-0.45-1.06c-0.12-0.29-0.23-0.57-0.34-0.86c-0.13-0.33-0.27-0.66-0.39-1
				c-0.11-0.29-0.22-0.59-0.33-0.88c-0.11-0.33-0.22-0.64-0.33-0.95c-0.1-0.31-0.19-0.62-0.29-0.92c-0.11-0.3-0.21-0.6-0.28-0.92
				c-0.1-0.3-0.18-0.62-0.28-0.92c-0.08-0.3-0.16-0.6-0.24-0.89c-0.08-0.31-0.16-0.62-0.23-0.93c-0.07-0.3-0.14-0.59-0.21-0.89
				c-0.07-0.29-0.15-0.59-0.21-0.91c-0.07-0.29-0.12-0.58-0.18-0.86c-0.07-0.3-0.12-0.6-0.18-0.91c-0.05-0.28-0.11-0.57-0.15-0.86
				c-0.06-0.3-0.11-0.58-0.14-0.88c-0.05-0.29-0.08-0.56-0.13-0.85c-0.04-0.29-0.07-0.58-0.12-0.85c-0.04-0.29-0.06-0.58-0.1-0.86
				c-0.04-0.28-0.06-0.54-0.1-0.81c-0.02-0.3-0.05-0.58-0.07-0.87c-0.04-0.27-0.06-0.51-0.07-0.75c-0.02-0.31-0.04-0.62-0.07-0.92
				c-0.01-0.22-0.02-0.45-0.04-0.66c-0.02-0.34-0.04-0.66-0.06-1c0-0.17-0.01-0.35-0.01-0.53c-0.01-0.39-0.02-0.79-0.04-1.18v-0.28
				c-0.05-3.37,0.16-6.29,0.4-8.56c0.28-2.46,0.62-4.15,0.75-4.78c2.16-1.65,22.78-17.26,32.09-21.15c0.5,0.33,1.62,1.06,3.22,2.09
				c6.39,4.08,20.4,12.73,32.79,18.21c0.4,0.18,0.81,0.36,1.21,0.53c0,0,0.05,0.01,0.07,0.02c0.33,0.13,0.66,0.29,1,0.42
				c0.21,0.1,0.42,0.18,0.64,0.27c0.28,0.11,0.56,0.23,0.82,0.34c0.21,0.07,0.42,0.16,0.62,0.24c0.5,4.75,3.19,29.27,4.78,43.72
				l0.08,0.76C248.35,326.85,248.14,327.06,247.92,327.24z M291.53,329.85c-4.19,0.71-8.54,1.06-12.92,1.06
				c-12.46,0-22.45-2.85-26.77-4.07c-0.97-0.29-1.57-0.46-1.98-0.53c-0.51-4.63-4.21-38.07-4.84-44.2
				c3.55-1.55,26.44-11.77,40.81-21.51c6.07,1.39,22.76,21.22,28.98,29.14C311.41,311.72,293.25,328.32,291.53,329.85z
				 M338.98,276.45c-1.12,0.93-8.54,6.96-17.73,10.58c-1.14,0.45-2.29,0.86-3.48,1.22c-0.23,0.07-0.46,0.15-0.69,0.21
				c-0.43,0.12-0.89,0.25-1.33,0.36c-3.03-3.85-21.52-26.97-29.27-29.41c0.11-0.48,0.28-1.2,0.46-2.14
				c1.06-5.56,2.84-18.78-0.18-35.06c-0.27-1.42-0.57-2.89-0.92-4.37c-0.02-0.16-0.07-0.31-0.11-0.47
				c-0.11-0.47-0.23-0.97-0.36-1.44c5.98-4.79,21.94-9.15,23.98-9.7c0.6,0.3,2.49,1.29,5.06,3.02c2.61,1.74,5.93,4.23,9.34,7.5
				c0.04,0.05,0.08,0.08,0.12,0.13c0.34,0.33,0.66,0.65,1,0.99c0.08,0.1,0.18,0.18,0.27,0.27c0.29,0.3,0.58,0.59,0.87,0.91
				c0.12,0.12,0.24,0.25,0.37,0.4c0.24,0.27,0.5,0.54,0.75,0.83c0.14,0.16,0.3,0.33,0.46,0.5c0.22,0.27,0.43,0.51,0.65,0.77
				c0.18,0.19,0.34,0.4,0.52,0.62c0.19,0.24,0.4,0.48,0.59,0.71c0.18,0.24,0.37,0.48,0.56,0.72c0.18,0.22,0.35,0.45,0.52,0.66
				c0.21,0.28,0.41,0.54,0.62,0.82c0.14,0.21,0.29,0.42,0.45,0.63c0.22,0.3,0.42,0.6,0.63,0.92c0.13,0.18,0.27,0.39,0.4,0.58
				c0.22,0.34,0.45,0.66,0.65,1.01c0.12,0.17,0.23,0.36,0.34,0.54c0.23,0.36,0.45,0.72,0.66,1.1c0.1,0.17,0.19,0.33,0.29,0.51
				c0.23,0.4,0.45,0.79,0.68,1.2c0.07,0.14,0.16,0.29,0.22,0.42c0.24,0.45,0.47,0.89,0.7,1.34c0.04,0.1,0.08,0.21,0.13,0.3
				c0.53,1.09,1.04,2.21,1.5,3.36C342.48,248.85,342.91,262.13,338.98,276.45z"
							/>
							<path
								id="XMLID_418_"
								class="st5"
								d="M202.64,258.89c-9.17,3.91-28.5,18.42-31.94,21.04c-13.57-13.66-15.25-23.43-15.45-26.13
				c-0.01-0.3-0.01-0.46-0.01-0.47c0.56-22.84,16.55-37.57,18.27-39.1c2.08-0.65,4.69-0.98,7.78-0.98c8.63,0,18.76,2.64,21.3,3.36
				C201.76,219.95,198.28,236.36,202.64,258.89z"
							/>
						</g>
					</g>
					<path
						id="XMLID_413_"
						class="st5"
						d="M308.43,205.1c-3.55,0.99-17.83,5.08-23.78,9.72c-3.03-2.52-22.34-18.19-40.32-21.33
		c0.17-2.02,0.87-9.26,3.06-18.15c1.06-0.14,4.12-0.52,8.3-0.52c8.56,0,21.01,1.52,31.8,8.74l0.1,0.04c0.05,0.01,0.3,0.11,0.71,0.28
		v0.01l0.17,0.06l0.07,0.04C291.29,185.25,300.55,190.37,308.43,205.1z"
					/>
					<path
						id="XMLID_393_"
						class="st5"
						d="M222.45,364.69c-1.14,0.31-2.6,0.47-4.38,0.47c-1.29,0-2.57-0.08-3.71-0.19
		c-0.95-0.3-1.91-0.63-2.85-0.97c-5.39-1.93-10.69-4.37-15.77-7.28c-0.66-0.39-1.3-0.77-1.98-1.17c-0.33-0.21-0.65-0.41-0.98-0.62
		l-2.16-1.38c-0.99-0.64-1.98-1.32-2.91-1.99c-0.27-0.19-0.54-0.39-0.8-0.56l-0.58-0.42c-4.84-3.56-9.35-7.55-13.39-11.85
		c-0.5-0.52-0.99-1.05-1.47-1.58c-1.55-3.2-2.05-5.47-2.21-6.28l7.4-6.36c2.68,3.26,17.54,20.13,38.88,21.52
		C215.81,353.12,220.91,362.13,222.45,364.69z"
					/>
					<path
						id="XMLID_392_"
						class="st5"
						d="M314.8,289.74c-3.39,21.98-21.55,38.59-23.27,40.11c-4.19,0.71-8.54,1.06-12.92,1.06
		c-12.46,0-22.45-2.85-26.77-4.07c-0.97-0.29-1.57-0.46-1.98-0.53c-0.51-4.63-4.21-38.07-4.84-44.2
		c3.55-1.55,26.44-11.77,40.81-21.51C291.89,261.99,308.58,281.82,314.8,289.74z"
					/>
					<path
						id="XMLID_391_"
						class="st5"
						d="M297.72,351.63l-5.76,6.06l1.39,0.51c0,0,5.7-3.64,5.88-3.76c0.18-0.12,3.66-2.58,3.9-2.81
		c0.24-0.24,0.97-0.89,0.63-0.91c-0.34-0.02-2.26-0.02-2.77,0.12C300.47,350.97,297.72,351.63,297.72,351.63z"
					/>
					<path
						id="XMLID_390_"
						class="st5"
						d="M339.57,276.54c0,0,1.93-9.01,2.45-13.06c0.52-4.05,0.73-10.62,0.73-10.62
		s1.42,5.47,1.37,5.67c-0.05,0.19,0.6,12.14,0.6,12.14l-0.46,9.87l-0.76,5.7l-1.88-5.18L339.57,276.54z"
					/>
				</g>
			</svg>

			<span class="text-sm text-bold">Spiel und Ticket auswählen</span>
		</div>
		<div class="item d-flex flex-column align-items-center text-center mb-2 px-1">
			<svg
				version="1.1"
				id="Ebene_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 400 400"
				style="enable-background:new 0 0 400 400;"
				xml:space="preserve"
				class="mb-1"
			>
				<style type="text/css">
					.st0 {
						fill: #004d9d;
					}
					.st2 {
						font-size: 208.161px;
					}
					.st3 {
						fill: #414141;
					}
				</style>
				<text transform="matrix(1 0 0 1 16.5347 387.5384)" class="st0 st1 st2">3</text>
				<g>
					<path
						class="st3"
						d="M364.73,110.29c-3.71-8.77-8.3-17.24-13.65-25.15c-5.29-7.84-11.37-15.21-18.07-21.91
		c-6.7-6.7-14.07-12.78-21.91-18.07c-7.91-5.35-16.38-9.94-25.15-13.65c-18.26-7.72-37.65-11.63-57.64-11.63
		c-18.08,0-35.74,3.22-52.5,9.58c-16.19,6.14-31.07,15.02-44.23,26.39c-13.08,11.3-23.99,24.64-32.43,39.67
		c-4.15,7.38-7.63,15.05-10.43,22.96l-22.92-2.03c-2.6-0.23-4.44,2.49-3.26,4.82l30.75,60.65c1.11,2.19,4.14,2.46,5.62,0.5
		l40.95-54.29c1.57-2.08,0.24-5.08-2.36-5.31l-22.25-1.97c0.08-0.18,0.15-0.37,0.23-0.55c3.07-7.25,6.86-14.24,11.28-20.79
		c4.38-6.49,9.42-12.59,14.96-18.14c5.55-5.55,11.65-10.58,18.14-14.96c6.54-4.42,13.54-8.22,20.79-11.28
		c7.38-3.12,15.1-5.52,22.95-7.13c8.07-1.65,16.38-2.49,24.7-2.49c8.32,0,16.63,0.84,24.7,2.49c7.85,1.61,15.57,4,22.95,7.13
		c7.25,3.07,14.24,6.86,20.79,11.28c6.49,4.38,12.59,9.42,18.14,14.96c5.55,5.55,10.58,11.65,14.96,18.14
		c4.42,6.55,8.22,13.54,11.28,20.79c3.12,7.38,5.52,15.1,7.13,22.95c1.65,8.07,2.49,16.38,2.49,24.7s-0.84,16.63-2.49,24.7
		c-1.61,7.85-4,15.57-7.13,22.95c-3.07,7.25-6.86,14.24-11.28,20.79c-4.38,6.49-9.42,12.59-14.96,18.14
		c-5.55,5.55-11.65,10.58-18.14,14.96c-6.54,4.42-13.54,8.22-20.79,11.28c-7.38,3.12-15.1,5.52-22.95,7.13
		c-8.07,1.65-16.38,2.49-24.7,2.49c-8.32,0-16.63-0.84-24.7-2.49c-7.85-1.61-15.57-4-22.95-7.13c-7.25-3.07-14.24-6.86-20.79-11.28
		c-6.49-4.38-12.59-9.42-18.14-14.96c-2.85-2.85-5.6-5.89-8.17-9.03c-2.45-2.99-6.08-4.71-9.94-4.71c-1.77,0-3.49,0.36-5.12,1.07
		c-3.7,1.62-6.37,4.8-7.32,8.73c-0.95,3.94-0.02,7.99,2.55,11.13c6.78,8.27,14.47,15.83,22.86,22.46
		c8.45,6.67,17.63,12.43,27.29,17.11c9.84,4.76,20.22,8.43,30.86,10.89c10.94,2.54,22.23,3.82,33.56,3.82
		c19.98,0,39.37-3.91,57.63-11.64c8.77-3.71,17.23-8.3,25.15-13.65c7.84-5.3,15.21-11.38,21.91-18.08
		c6.7-6.7,12.78-14.07,18.08-21.91c5.35-7.91,9.94-16.38,13.65-25.15c7.72-18.25,11.64-37.64,11.64-57.63
		C376.36,147.94,372.45,128.55,364.73,110.29z"
					/>
				</g>
				<g>
					<g>
						<path
							class="st3"
							d="M231.61,116.47c-1.87,0-3.75,0.42-5.62,2.5v26.85h32.89v13.95h-32.89v6.87h32.89v13.95h-32.89v34.14
			c1.87,2.08,3.75,2.5,5.62,2.5c3.54,0,5.2-1.67,5.2-5.41v-22.48h29.98v26.44c0,17.9-11.87,26.85-35.18,26.85
			c-12.91,0-25.19-3.54-35.6-12.07v-49.96h-6.24v-13.95h6.87v-6.87h-6.87v-13.95h6.24v-42.67c10.41-8.53,22.69-12.07,35.6-12.07
			c23.31,0,35.18,8.95,35.18,26.85v16.44l-29.98,5.62v-18.11C236.82,118.13,235.15,116.47,231.61,116.47z"
						/>
					</g>
				</g>
			</svg>

			<span class="text-sm text-bold">Rückerstattungsmethode wählen</span>
		</div>
		<div class="item d-flex flex-column align-items-center text-center mb-2 px-1">
			<svg
				version="1.1"
				id="Ebene_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 400 400"
				style="enable-background:new 0 0 400 400;"
				xml:space="preserve"
				class="mb-1"
			>
				<style type="text/css">
					.st0 {
						fill: #004d9d;
					}
					.st2 {
						font-size: 208.161px;
					}
					.st3 {
						fill: #414141;
					}
				</style>
				<text transform="matrix(1 0 0 1 16.5347 387.5384)" class="st0 st1 st2">4</text>
				<g>
					<g>
						<g>
							<path
								class="st3"
								d="M228.06,163.74c-1.87,0-3.75,0.42-5.62,2.5v26.85h32.89v13.95h-32.89v6.87h32.89v13.95h-32.89v34.14
				c1.87,2.08,3.75,2.5,5.62,2.5c3.54,0,5.2-1.67,5.2-5.41v-22.48h29.98v26.44c0,17.9-11.87,26.85-35.18,26.85
				c-12.91,0-25.19-3.54-35.6-12.07v-49.96h-6.24V213.9h6.87v-6.87h-6.87v-13.95h6.24v-42.67c10.41-8.53,22.69-12.07,35.6-12.07
				c23.31,0,35.18,8.95,35.18,26.85v16.44l-29.98,5.62v-18.11C233.26,165.4,231.6,163.74,228.06,163.74z"
							/>
						</g>
					</g>
					<g>
						<g>
							<g>
								<path
									class="st3"
									d="M314.7,40.78v318.44c0,8.38-5.07,24.24-24.24,24.24h-45.47v-3.01c0-0.04-0.06-4.82-2.42-9.44
					c-2.99-5.83-8.3-8.78-15.8-8.78c-0.04,0-4.82,0.06-9.44,2.42c-5.83,2.99-8.78,8.3-8.78,15.8v3.01h-45.47
					c-8.38,0-24.24-5.07-24.24-24.24V40.78c0-19.17,15.85-24.24,24.24-24.24h45.47v3.01c0,7.5,2.95,12.81,8.78,15.8
					c4.61,2.36,9.4,2.42,9.45,2.42c7.49,0,12.8-2.95,15.79-8.78c2.36-4.61,2.42-9.4,2.42-9.45l0.02-2.99l2.99-0.01h42.46
					C309.63,16.54,314.7,32.4,314.7,40.78z M250.81,377.44h39.65c7.5,0,12.81-2.95,15.8-8.78c2.36-4.61,2.42-9.4,2.42-9.45V40.78
					c0-0.04-0.06-4.82-2.42-9.44c-2.99-5.83-8.3-8.78-15.8-8.78h-39.65c-1.09,8.67-6.98,21.23-24.04,21.23
					c-7.93,0-22.53-4.53-24.1-21.23h-39.59c-0.04,0-4.82,0.06-9.44,2.42c-5.83,2.99-8.78,8.3-8.78,15.8v318.44
					c0,7.5,2.95,12.81,8.78,15.8c4.55,2.33,9.26,2.42,9.44,2.42h39.58c1.57-16.7,16.17-21.23,24.1-21.23
					C243.83,356.21,249.72,368.77,250.81,377.44z"
								/>
								<g
									id="g839_00000152961161735491582920000004199855769032980150_"
									transform="matrix(1,0,0,0.9549874,7.5595238,8.418172)"
								>
									<path
										class="st3"
										d="M170.3,84.7c0,1.02-0.79,1.85-1.77,1.85h-20.27c-0.98,0-1.77-0.83-1.77-1.85c0-1.02,0.79-1.85,1.77-1.85
						h20.27C169.5,82.85,170.3,83.68,170.3,84.7z"
									/>
									<path
										class="st3"
										d="M210.84,84.7c0,1.02-0.79,1.85-1.77,1.85H188.8c-0.98,0-1.77-0.83-1.77-1.85c0-1.02,0.79-1.85,1.77-1.85
						h20.27C210.05,82.85,210.84,83.68,210.84,84.7z"
									/>
									<path
										class="st3"
										d="M251.39,84.7c0,1.02-0.79,1.85-1.77,1.85h-20.27c-0.98,0-1.77-0.83-1.77-1.85c0-1.02,0.79-1.85,1.77-1.85
						h20.27C250.6,82.85,251.39,83.68,251.39,84.7z"
									/>
									<path
										class="st3"
										d="M291.94,84.7c0,1.02-0.79,1.85-1.77,1.85H269.9c-0.98,0-1.77-0.83-1.77-1.85c0-1.02,0.79-1.85,1.77-1.85
						h20.27C291.15,82.85,291.94,83.68,291.94,84.7z"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>

			<span class="text-sm text-bold">Ticket(s) auf tickets.schalke04.de verkaufen</span>
		</div>
	</div>
</div>

<style>
	.highlight {
		background-color: #e6e6e6;
	}
	.item {
		width: 25%;
	}
	.item svg {
		width: 100%;
		max-width: 75px;
		height: auto;
	}

	@media (max-width: 767px) {
		.item {
			width: 50%;
		}
	}
</style>
